import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'time'
})
export class TimePipe implements PipeTransform {

  transform(value: string, args?: any): any {
    if (! value) {
      return null;
    }
    const timeWithMillisPattern = /^([0-9]{1,2}:[0-9]{2}):[0-9]{2}$/;
    if (value.match(timeWithMillisPattern)) {
      return value.replace(timeWithMillisPattern, '$1');
    }
    return value;
  }

}
